/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PatchReadinessStatistics {
    getFixupPrototypeFunction() { return PatchReadinessStatistics.fixupPrototype; }

    static newInstance(model: Partial<PatchReadinessStatistics>): PatchReadinessStatistics {
        let obj = Object.assign(new PatchReadinessStatistics(), model);
        PatchReadinessStatistics.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PatchReadinessStatistics>): PatchReadinessStatistics {
        if (!model) return null;
        return PatchReadinessStatistics.newInstance(<PatchReadinessStatistics> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PatchReadinessStatistics) {
        if (!obj) return;

        models.PatchReadinessStatistics.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PatchReadinessStatistics): boolean {
        Object.setPrototypeOf(obj, PatchReadinessStatistics.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.supported_resources === undefined) {
            this.supported_resources = 0;
        }
        if (this.ready_to_update === undefined) {
            this.ready_to_update = 0;
        }
    }

    /**
     * Total number of resources for which the dashboard needs to present the data.
     */
    supported_resources: number;

    /**
     * Total number of instance/vm which is ready for updating the patch.
     */
    ready_to_update: number;

}
